import MyAccount from '@/views/account/MyAccount.vue';
export const userAccountRoutes = [
  {
    path: '/account/my-profile',
    name: 'MyProfile',
    component: MyAccount,
    meta: { requiresAuth: true },
  },
];
